<template>
  <div :class="{fullscreen:fullscreen}" class="tinymce-container" :style="{width:containerWidth}">
    <textarea :id="tinymceId" class="tinymce-textarea" />
  </div>
</template>

<script>
/**
 * docs:
 * https://panjiachen.github.io/vue-element-admin-site/feature/component/rich-editor.html#tinymce
 */
import editorImage from './components/EditorImage'
import plugins from './plugins'
import toolbar from './toolbar'
import load from './dynamicLoadScript'

// why use this cdn, detail see https://github.com/PanJiaChen/tinymce-all-in-one
const tinymceCDN = 'https://cdn.tiny.cloud/1/898s2kiabfb5pcbecx6b5h0qbesqq2zu7yqo60qkc54b0w9b/tinymce/6/tinymce.min.js'
// const tinymceCDN = 'https://cdn.jsdelivr.net/npm/tinymce-all-in-one@4.9.3/tinymce.min.js'


export default {
  name: 'Tinymce',
  components: { editorImage },
  props: {
    id: {
      type: String,
      default: function() {
        return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '')
      }
    },
	readonly:  {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    toolbar: {
      type: String,
      default: ''
    },
    menubar: {
      type: String,
      default: 'file edit insert view format table'
    },
    height: {
      type: [Number, String],
      required: false,
      default: 580,
	  // default: 'auto'
    },
    width: {
      type: [Number, String],
      required: false,
      default: 'auto'
    }
  },
  data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        'en': 'en',
        'zh': 'zh_CN',
        'es': 'es_MX',
        'ja': 'ja'
      }
    }
  },
  computed: {
    containerWidth() {
      const width = this.width
      if (/^[\d]+(\.[\d]+)?$/.test(width)) { // matches `100`, `'100'`
        return `${width}px`
      }
      return width
    }
  },
  watch: {
    value(val) {
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() =>
          window.tinymce.get(this.tinymceId).setContent(val || ''))
      }
    }
  },
  mounted() {
    this.init()
  },
  activated() {
    if (window.tinymce) {
      this.initTinymce()
    }
  },
  deactivated() {
    this.destroyTinymce()
  },
  destroyed() {
    this.destroyTinymce()
  },
  methods: {
    init() {
      // // dynamic load tinymce from cdn
      // load(tinymceCDN, (err) => {
      //   if (err) {
      //     this.$message.error(err.message)
      //     return
      //   }
        this.initTinymce()
      // })
    },
    initTinymce() {
      const _this = this
      window.tinymce.init({
        selector: `#${this.tinymceId}`,
		//版本低没反应：placeholder: 'Please enter your chapter content here. Chinese characters, special characters and emoji expressions are not allowed here.',
        language: this.languageTypeList['en'],
        height: this.height,
        body_class: 'panel-body ',
        object_resizing: false,
		statusbar: false,//隐藏下面的统计数字功能
        toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
		// toolbar: false, //工具栏
        // menubar: this.menubar,
		menubar: false, // 菜单栏 false不显示
       //plugins: plugins,//右键图片、表格等
		content_style:"p{margin:0px; border:0px;padding:0px;font-size:15px;font-family: 'Times New Roman';line-height: 20px;}",
		// plugins: "autoresize", // 设置高度
        end_container_on_empty_block: true,
		browser_spellcheck:true,//拼写检查
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        link_title: false,
       nonbreaking_force_tab: true, // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
		
		//contenteditable: false,
		readonly:this.readonly,
		
		//禁用添加HTML结束标签
		/* verify_html : false,
		verify_css_classes : true, 
		cleanup : false,
		cleanup_on_startup : false,
		protect:[
		        /\<\/?(if|endif)\>/g, //<if> & </endif>
		        /\<xsl\:[^>]+\>/g,    //<xsl:...>
		        /<\?php.*?\?>/g,      //php代码
		    ],
		 exact:true,
		 element_format:'html',
		 br_in_pre:true,
		 end_container_on_empty_block:false,
		 typeahead_urls: false,
		convert_fonts_to_spans: false,//font标签转span
		forced_root_block:false,//强制根节点块元素 */
		//force_p_newlines : true ,
		
		//plugins:"paste",
		paste_preprocess: function(plugin, args) {//复制

			console.log("复制内容",args.content);
 			var reg00 = new RegExp("\>\</p\>", 'g')
			args.content = args.content.replace(reg00, ">^^^") 
 			var reg0 = new RegExp("&nbsp;\</p\>", 'g')
			args.content = args.content.replace(reg0, "^^^")
			var reg1 = new RegExp("\\s+\<\/p\>", 'g')
			args.content = args.content.replace(reg1, "^^^")
			var reg10 = new RegExp("\</p\>", 'g')
			args.content = args.content.replace(reg10, "^^^")
			var reg2 = new RegExp("\<br \/\>", 'g')
			args.content = args.content.replace(reg2, "^^^") 
			var reg4 = new RegExp("\<br\>", 'g')
			args.content = args.content.replace(reg4, "^^^")
			var reg5 = new RegExp("&nbsp;\</div\>", 'g')
			args.content = args.content.replace(reg5, "^^^")
			var reg6 = new RegExp("<(\S*?)[^>]*>.*?|<.*? />", 'g')
			args.content = args.content.replace(reg6, "")
			var reg51 = new RegExp("\\^\\^\\^\\^\\^\\^", 'g')//处理百度复制进来的会有两行的情况
			args.content = args.content.replace(reg51, "^^^")
			var reg52 = new RegExp("\\^\\^\\^\\n\\^\\^\\^", 'g')//处理在富文本复制粘贴会有两行的情况
			args.content = args.content.replace(reg52, "^^^")
		 	var reg7 = new RegExp("\\^\\^\\^", 'g')
			args.content = args.content.replace(reg7, "<br>")
			console.log("复制处理后内容",args.content);
		},
        init_instance_callback: editor => {
          if (_this.value) {
            editor.setContent(_this.value)
          }
          _this.hasInit = true
		//  editor.getBody().setAttribute("contenteditable",false)//不可编辑
          // editor.on('NodeChange Change KeyUp SetContent', (e) => {
		editor.on('dblclick', (e) => {
            this.hasChange = true
            // this.$emit('input', editor.getContent())
			this.$emit('eventHandle',{e,editor})
        }),
		editor.on('Change KeyUp', (e) => {
			this.$emit('contentHandle',{e,editor})
		}),
		editor.on('MouseDown', (e) => {
			this.$emit('mousedown',{e,editor})
		}),
		editor.on('MouseUp', (e) => {
			this.$emit('mouseup',{e,editor})
		}),
		editor.on('KeyDown', (e) => {
			// console.log("tinymce.e",e);
			// console.log("e.seletion",e.Selection);
			this.$emit('keydown',{e,editor})
		}),
		editor.on('Paste', (e) => {
			this.$emit('paste',{e,editor})
		})
        },
        setup(editor) {
          editor.on('FullscreenStateChanged', (e) => {
            _this.fullscreen = e.state
          })
        },
        // it will try to keep these URLs intact
        // https://www.tiny.cloud/docs-3x/reference/configuration/Configuration3x@convert_urls/
        // https://stackoverflow.com/questions/5196205/disable-tinymce-absolute-to-relative-url-conversions
        convert_urls: false
        // 整合七牛上传
        // images_dataimg_filter(img) {
        //   setTimeout(() => {
        //     const $image = $(img);
        //     $image.removeAttr('width');
        //     $image.removeAttr('height');
        //     if ($image[0].height && $image[0].width) {
        //       $image.attr('data-wscntype', 'image');
        //       $image.attr('data-wscnh', $image[0].height);
        //       $image.attr('data-wscnw', $image[0].width);
        //       $image.addClass('wscnph');
        //     }
        //   }, 0);
        //   return img
        // },
        // images_upload_handler(blobInfo, success, failure, progress) {
        //   progress(0);
        //   const token = _this.$store.getters.token;
        //   getToken(token).then(response => {
        //     const url = response.data.qiniu_url;
        //     const formData = new FormData();
        //     formData.append('token', response.data.qiniu_token);
        //     formData.append('key', response.data.qiniu_key);
        //     formData.append('file', blobInfo.blob(), url);
        //     upload(formData).then(() => {
        //       success(url);
        //       progress(100);
        //     })
        //   }).catch(err => {
        //     failure('出现未知问题，刷新页面，或者联系程序员')
        //     console.log(err);
        //   });
        // },
      })
    },
    destroyTinymce() {
	  console.log("window.tinymce",window.tinymce);
	  if(window.tinymce==null)return;//有时会报没有get方法
      const tinymce = window.tinymce.get(this.tinymceId)
      if (this.fullscreen) {
        tinymce.execCommand('mceFullScreen')
      }

      if (tinymce) {
        tinymce.destroy()
      }
    },
    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value)
    },
    getContent() {
      window.tinymce.get(this.tinymceId).getContent()
    },
    imageSuccessCBK(arr) {
      arr.forEach(v => window.tinymce.get(this.tinymceId).insertContent(`<img class="wscnph" src="${v.url}" >`))
    }
/* 	,
	tinymce.activeEditor.on('keyup', function(e) { 
     console.debug("keyup"); 
    }); */
  }
}
</script>

<style lang="scss" scoped>
.tinymce-container {
  position: relative;
  line-height: normal;
}

.tinymce-container {
  ::v-deep {
    .mce-fullscreen {
      z-index: 10000;
    }
  }
}

.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}

.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
  /*z-index: 2005;*/
}

.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}

.editor-upload-btn {
  display: inline-block;
}
</style>
